import { Alert, AlertDescription } from "@jem-hr/jem-ui";
import { Monitor } from "lucide-react";

export function DesktopOnlyBanner() {
  return (
    <Alert
      variant="info"
      className="sm:hidden mb-md !flex-row items-center gap-sm"
      hideIcon
    >
      <Monitor size={16} className="text-primary-navy-600 shrink-0" />
      <div className="flex-1">
        <p className="font-semibold text-sm text-greyscale-text-title leading-tight">
          Desktop-only feature
        </p>
        <AlertDescription className="pl-0 text-xs">
          View on a larger screen for the full experience. Time &amp;
          Attendance is the only feature currently optimised for mobile.
        </AlertDescription>
      </div>
    </Alert>
  );
}
